import { AuthXUserIdentityToken } from '@/types'
import { request } from '@/store/client'

/**
  Authenticates an SSO request from a third party

  Note: Only a select few partners utilise this service
 */
export const authenticateAgainstPartnerSSO = async (partnerCode: string, token: string): Promise<AuthXUserIdentityToken> => {
  const response = await request({
    url: `/partners/${encodeURIComponent(partnerCode)}/sso`,
    method: 'post',
    data: { token },
  })

  return response.data
}
